import React, { DOM } from 'react';
import reactor from 'data/reactor';
import { Link } from 'react-router-dom';
import { Immutable } from 'nuclear-js';
import PropTypes from 'prop-types';
import CreateReactClass from 'create-react-class';

import Actions from 'data/actions';
import DataLoader from 'data/loader';
import RosterGetters from 'data/roster/getters';
import CommonValues from 'resources/common-values';
import Analytics from 'utils/analytics';
import { DeepCompareComponentShouldUpdateMixin } from 'utils/react';

export default CreateReactClass({
    displayName: 'StudentsList',
    mixins: [DeepCompareComponentShouldUpdateMixin],

    propTypes: {
        students: PropTypes.instanceOf(Immutable.List),
    },

    render() {
        if (!this.props.students || this.props.students.count() == 0) {
            return (
                <div className="student-error-msg">
                    <h4 className="text-center">
                        {' '}
                        To select a student, please return to the <br />
                        <Link
                            id="student-selection-link"
                            key="student-selection-link"
                            to="/students"
                            onClick={() =>
                                Analytics.recordButtonClick(
                                    CommonValues.SectionIDs.studentInfo,
                                    'return-to-create-report'
                                )
                            }
                            className="student-selection-link"
                        >
                            Create Student Profile Report page
                        </Link>
                    </h4>
                </div>
            );
        } else {
            let studentRows = this.props.students.map((student, idx) => {
                const studentBid = student.get('studentBid');

                const studentName = (
                    <Link
                        to="/students/profile"
                        state={{ studentBid: studentBid }}
                        onClick={() => {
                            Analytics.recordButtonClickWithExpandedModuleAsLabel(
                                CommonValues.SectionIDs.studentInfo,
                                'select-student-in-class-list'
                            );

                            const outgoingStudentBid = reactor.evaluate(RosterGetters.selectedStudentBid);
                            // Previously, when the user clicks on the student name that is currently in view,
                            // the entire page would refresh. This is unnecessary and poor ux.  The following
                            // return short-circuit fixes that issue.
                            if (outgoingStudentBid === studentBid) {
                                Actions.runtime.toggleStudentListPopover(false);
                            } else {
                                const mainElement = document.getElementById('report-content');
                                mainElement.className =
                                    mainElement.className.replace(' selecting-student', '') + ' selecting-student'; // ensure that the fade-out transitions are set

                                /******************************************************************************
                                 *                                  ATTENTION
                                 *
                                 *  The following setTimeout is the possible source of an app-breaking bug. It
                                 *  may cause race conditions throughout the app.  We have shored up the issues
                                 *  we know of caused by this in other parts of the code. We have determined that
                                 *  it is necessary to remain the way it is for now because css transitions break
                                 *  without the timeout.  This comment is just to make anyone aware in the future.
                                 *
                                 **************************************************************************** */
                                setTimeout(() => {
                                    reactor.batch(() => {
                                        Actions.runtime.toggleStudentListPopover(false);
                                        Actions.roster.selectStudentBid(studentBid);
                                        Actions.student.changeSelectedTermNumber(
                                            studentBid,
                                            CommonValues.mostRecentTermNumber
                                        );
                                    });
                                    mainElement.className = mainElement.className.replace(' selecting-student', '');
                                }, 750);

                                DataLoader.loadStudents(studentBid);
                            }
                        }}
                        id={studentBid}
                        key={studentBid}
                        data-testid={`${idx}-student-list-item`}
                    >
                        {student.get('fullName')}
                    </Link>
                );

                return <li key={'student-' + studentBid}>{studentName}</li>;
            });

            return (
                <div className="student-list-popover-table-wrapper">
                    <ul key="student-list-table">{studentRows}</ul>
                </div>
            );
        }
    },
});
